import styled from 'styled-components';

export const Title = styled.div`
  background: ${({ titleIcon }) => `url('${titleIcon}') 0px 1px no-repeat`};
  background-size: 11px 11px;
  padding-left: 24px;
  color: white;
  letter-spacing: 2px;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  margin-bottom: 20px;
`;
